export function createCheatsheetBlock(type) {

    const id = `${type}_${crypto.randomUUID().slice(0, 6)}`;

    switch (type) {

        case "heading":
            return {
                id,
                type,
                config: {
                    level: 2,
                    text: ""
                }
            };

        case "text":
            return {
                id,
                type,
                config: {
                    text: ""
                }
            };

        case "image":
            return {
                id,
                type,
                config: {
                    src: "",
                    alt: "",
                    caption: ""
                }
            };

        case "code":
            return {
                id,
                type,
                config: {
                    language: "python",
                    code: ""
                }
            };

        case "list":
            return {
                id,
                type,
                config: {
                    ordered: false,
                    items: [""]
                }
            };

        case "info":
            return {
                id,
                type,
                config: {
                    title: "",
                    text: ""
                }
            };

        case "warning":
            return {
                id,
                type,
                config: {
                    title: "",
                    text: ""
                }
            };

        default:
            return null;
    }
}